"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKELETON_CATALOGUE_DESKTOP = exports.MAIN_CATEGORY_DESKTOP = void 0;
const SKELETON_CATALOGUE_DESKTOP = exports.SKELETON_CATALOGUE_DESKTOP = 'skeleton-catalogue-desktop';
const MAIN_CATEGORY_DESKTOP = exports.MAIN_CATEGORY_DESKTOP = 'main-category-desktop';